module.exports = __webpack_public_path__ + "static/media/dashboardHomeIcon.c22536de.svg";